// src/modules/app-views/services/pages/Init/modals/DataImportModal/StepSummary.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Card, Descriptions, Tag, Space, Alert, Typography } from 'antd';
import { FileExcelOutlined, PlayCircleOutlined } from '@ant-design/icons';
import translateX from 'utils/translateX';

const { Text } = Typography;

// *******************************************************************************
// STEP CONTENT COMPONENT
// *******************************************************************************
const StepSummaryContent = ({ fileInfo, mappedCount, ignoredCount, conflictStrategy, duplicateKey }) => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 9. UI
  // ─────────────────────────────────────────────────────────────────────────────
  return (
    <div>
      <Text type="secondary">{translateX('data_import_summary_description')}</Text>

      <Card size="small" style={{ marginTop: 16 }}>
        <Descriptions column={1} size="small">
          <Descriptions.Item label={translateX('file')}>
            <Space>
              <FileExcelOutlined />
              {fileInfo?.originalName}
            </Space>
          </Descriptions.Item>
          <Descriptions.Item label={translateX('data_import_total_records')}>
            <Text strong>{fileInfo?.totalRows}</Text>
          </Descriptions.Item>
          <Descriptions.Item label={translateX('mapping')}>
            <Space>
              <Tag color="green">{mappedCount} {translateX('data_import_mapped_fields')}</Tag>
              <Tag color="default">{ignoredCount} {translateX('data_import_ignored_fields')}</Tag>
            </Space>
          </Descriptions.Item>
          <Descriptions.Item label={translateX('data_import_conflict_strategy')}>
            {conflictStrategy === 'ignore'
              ? translateX('data_import_conflict_ignore')
              : translateX('data_import_conflict_overwrite')
            }
          </Descriptions.Item>
          <Descriptions.Item label={translateX('data_import_duplicate_key')}>
            <Tag color="blue">{duplicateKey || 'sku'}</Tag>
          </Descriptions.Item>
        </Descriptions>
      </Card>

      <Alert
        type="info"
        showIcon
        style={{ marginTop: 16 }}
        title={`${fileInfo?.totalRows || 0} registros serão processados. Esta ação não pode ser desfeita.`}
      />
    </div>
  );
};

// *******************************************************************************
// STEP CONFIGURATION
// *******************************************************************************
const stepSummary = ({ fileInfo, mappedCount, ignoredCount, conflictStrategy, duplicateKey, resetExecution }) => ({
  stepTitle: 'summary',
  stepTooltip: 'data_import_summary_description',
  content: () => (
    <StepSummaryContent
      fileInfo={fileInfo}
      mappedCount={mappedCount}
      ignoredCount={ignoredCount}
      conflictStrategy={conflictStrategy}
      duplicateKey={duplicateKey}
    />
  ),
  nextButtonText: 'data_import_start',
  nextButtonIcon: <PlayCircleOutlined />,
  // Reset execution state when returning from processing step (allows re-import)
  onEnter: () => {
    resetExecution?.();
  },
});

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default stepSummary;
